import React, { useState } from 'react'
import { Col, Row } from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import { showLoader } from "../../../components/loader/loader";
import TypePlaceList from './_list';
import TypePlaceForm from './_form';

const TypePlace = () => {
    const [loading] = useState(false)
    const [viewMode, setViewMode] = useState("LIST")
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const setForm = (editModeP, data, viewModeP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setItem(data);
        setViewMode(viewModeP ? viewModeP : "LIST")
    }

    return (<>
        {loading && showLoader()}

        {
            viewMode === "LIST"  ? <> 
                <Row>
                    <Col md="12">
                        <div className="d-flex align-items-center">
                            <div className="ml-auto paddingAdd">
                                <ButtonNew onClick={() => setForm(null, null, "FORM")}/>
                            </div> 
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col> 
                        <TypePlaceList setForm={ setForm }/> 
                    </Col>
                </Row>
            </> : <Row>
                <Col> 
                    <TypePlaceForm
                        setForm={ setForm } 
                        updateItem={ setItem } 
                        item={ item } 
                        editMode={ editMode } 
                    />
                </Col>
            </Row>

        }
    </>)
}

export default TypePlace 
